module.exports = __webpack_public_path__ + "media/img/auth/logo-b5cd0d0911fc9f0eef4e2f126336a232.svg";